import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recent: {
		id: 'navigation-apps-sidebar-nav4-recent.recent',
		defaultMessage: 'Recent',
		description: 'Label for the recent nav menu item in the sidebar',
	},
});
